__turbopack_context__.v({
  "list": "List-module-scss-module__27ejcW__list",
  "listStyle-check": "List-module-scss-module__27ejcW__listStyle-check",
  "listStyle-minus": "List-module-scss-module__27ejcW__listStyle-minus",
  "listStyle-none": "List-module-scss-module__27ejcW__listStyle-none",
});
